import React, { Component } from "react";
import ProductCard from "./ProductCard";
import FilterButton from "./FilterButton";

class ProductListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded || true,
    };
    this.bindThis();
  }

  bindThis() {
    // Make 'this' work in event functions
    this.setExpandedState = this.setExpandedState.bind(this);
  }

  setExpandedState(item) {
    this.setState({
      expanded: item.selected,
    });
  }

  render() {
    let className = "c-product-listing";
    if (this.state.expanded) {
      className += " c-product-listing--show-technical-data";
    }

    return (
      <div className={className}>
        <div className="c-product-listing__header">
          {!this.props.loading && (
            <>
                {(this.props.items.reduce((a, v) => (a = a + v.articleCount), 0)) > 0 ? (
                    <h3 className="c-product-listing__heading">
                        {this.props.heading} ({this.props.items.reduce((a, v) => (a = a + v.articleCount), 0)})
                    </h3>
                ) : null}
              <FilterButton
                item={{
                  value: "show-technical-data",
                  text: this.props.expandText,
                  selected: this.state.expanded,
                  icon: "icon-settings icon-1-5x",
                }}
                className="c-toggle-button"
                onClick={this.setExpandedState}
              />
            </>
          )}
        </div>
        <div className="c-product-listing__outer">
          {!this.props.loading &&
            this.props.items.map((product) => {
              return <ProductCard key={product.name} item={product} />;
            })}
        </div>
      </div>
    );
  }
}

export default ProductListing;
